import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Share2, ZoomIn } from 'lucide-react';
import { Button } from './ui/button';
import { getAlbumTitleFontClass } from '../lib/albumTitleFonts';

const AlbumModal = ({ album, isOpen, onClose, onImageClick }) => {
  if (!album) return null;
  const titleFontClass = getAlbumTitleFontClass(album.titleFont);

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: album.title,
        text: `Check out this beautiful wedding album: ${album.title}`,
        url: window.location.href
      }).catch(() => {});
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center justify-between">
            <div>
              <div className={`text-gray-900 ${titleFontClass}`}>{album.title}</div>
              <div className="text-sm text-gray-500 font-normal mt-1">
                {album.location} • {album.date} • {album.images.length} Photos
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                size="icon"
                onClick={handleShare}
                className="hover:bg-gray-100"
              >
                <Share2 className="w-4 h-4" />
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>

        {/* Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-6">
          {album.images.map((imageUrl, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-lg aspect-square"
              onClick={() => onImageClick(imageUrl, album.images)}
            >
              <img
                src={imageUrl}
                alt={`${album.title} - Photo ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <ZoomIn className="w-8 h-8 text-white" />
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AlbumModal;
